export default __webpack_public_path__ + "static/media/tauroDemo01DownloadMT4.cce331b7.jpg";